// extracted by mini-css-extract-plugin
export default {"content":"SimpleModal_content__ZERUw","title":"SimpleModal_title__alxMV"};